import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Receipts: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 13.1764V3.13723H3.13726V12.549C3.13726 12.8955 3.41818 13.1764 3.76471 13.1764H10.6667ZM12.549 14.4313H3.76471C2.72512 14.4313 1.88235 13.5886 1.88235 12.549V2.50978C1.88235 2.16325 2.16328 1.88232 2.50981 1.88232H11.2941C11.6407 1.88232 11.9216 2.16325 11.9216 2.50978V6.90193H14.4314V12.549C14.4314 13.5886 13.5886 14.4313 12.549 14.4313ZM11.9216 8.15683V12.549C11.9216 12.8955 12.2025 13.1764 12.549 13.1764C12.8956 13.1764 13.1765 12.8955 13.1765 12.549V8.15683H11.9216ZM4.39216 4.39213H8.15686V8.15683H4.39216V4.39213ZM5.64706 5.64703V6.90193H6.90196V5.64703H5.64706ZM4.39216 8.78428H9.41177V10.0392H4.39216V8.78428ZM4.39216 10.6666H9.41177V11.9215H4.39216V10.6666Z"
        fill={color}
      />
    </svg>
  );
};

export default Receipts;
